import { render, staticRenderFns } from "./subnodes.vue?vue&type=template&id=37e0b2fe&"
import script from "./subnodes.vue?vue&type=script&lang=js&"
export * from "./subnodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports